import { apiGet } from "../../utils/api";
import React, { useEffect, useState } from "react";
import moment from "moment";
import "moment/locale/pt-br";

const NewsHome = (props) => {
  const [news, setNews] = useState([]);

  useEffect(() => {
    async function exibir() {
      const payload = apiGet("/news");
      setNews((await payload).data.data);
    }
    exibir();
  }, []);

  var subset = null;

  if (news && news.length) {
    subset = news.slice(0, props.newsToShow);
  }

  return (
    <>
      {subset
        ? subset.map((newww) => {
            return (
              <div className="col-lg-3 my-5" key={newww.news_id}>
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title">
                      <a
                        className="link2"
                        href={'readmore/"' + newww.title + '"'}
                      >
                        {newww.title}
                      </a>
                    </h5>
                    <p className="card-text news">
                      <span>{moment(newww.date).format("LL")}</span>
                      <br />
                      {newww.description.length > 200 ? (
                        <>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: newww.description
                                .replaceAll("<p>", "")
                                .replaceAll("</p>", "")
                                .substr(0, 200),
                            }}
                          ></span>
                          <span> ...</span>
                        </>
                      ) : (
                        <>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: newww.description
                                .replaceAll("<p>", "")
                                .replaceAll("</p>", ""),
                            }}
                          ></span>
                        </>
                      )}
                    </p>
                    <a
                      className="btn btn-primary"
                      href={'readmore/"' + newww.title + '"'}
                    >
                      Leia mais
                    </a>
                  </div>
                </div>
              </div>
            );
          })
        : null}
    </>
  );
};

export default NewsHome;
